export default "assets/images/logo-da335aae.png";